import Ebike from "../../Images/eBike.png";

const WhyInsureWithVelosure = () => {
  return (
    <div className="container-fluid whiteBG pr oh">
      <div className="container Why_Icons">
        <div className="row">
          <div className="col-12 mt-3">
            <h3>
              Why Insure with
              <span className="blueFont"> Velosure?</span>
            </h3>
            <p className="blueFont">Looking to protect your cycle?</p>
            <p>
              We understand how important your bike is to you, which is why we
              include important features as standard. To view the full list of
              features, <a href="/coverfeatures">click here</a>.
            </p>
          </div>
          {/* Top row of icons */}
          <div className="col-12 col-md-6 col-lg-4 col-xl-4 pr-10">
            <div className="iconBlockBlueLeft mb-3 ">
              <svg
                id="Group_2132"
                dataname="Group 2132"
                width="49.989"
                height="50.333"
                viewBox="0 0 49.989 50.333"
              >
                <defs>
                  <clipPath id="clipPath8">
                    <rect
                      id="Rectangle_795"
                      dataname="Rectangle 795"
                      width="49.989"
                      height="50.333"
                      fill="#fff"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_1760"
                  dataname="Group 1760"
                  transform="translate(0 0)"
                  clipPath="url(#clipPath8)"
                >
                  <path
                    id="Path_2085"
                    dataname="Path 2085"
                    d="M48.841,32.139H34.091V20.04a1.148,1.148,0,0,0-1.148-1.148H31.1V15.817a.8.8,0,0,0-.8-.8H27.564V11.4a.78.78,0,0,0-.009-.087A4.552,4.552,0,0,0,28.99,9.406a.784.784,0,0,0,.094-.073c4.269-4.091,4.789-4.571,4.847-4.624.015-.012.029-.026.043-.04A2.213,2.213,0,0,0,32.42.883H30.208A.8.8,0,0,0,29.41,0H20.578a.8.8,0,0,0-.8.883H17.568a2.214,2.214,0,0,0-1.554,3.786c.014.014.028.028.043.04.058.052.577.532,4.848,4.624a.809.809,0,0,0,.089.07,4.55,4.55,0,0,0,1.438,1.914.758.758,0,0,0-.009.085v3.612H19.7a.8.8,0,0,0-.8.8v3.074H17.046A1.148,1.148,0,0,0,15.9,20.04v6.8H1.148A1.148,1.148,0,0,0,0,27.988v21.2a1.148,1.148,0,0,0,1.148,1.148H48.841a1.148,1.148,0,0,0,1.148-1.148v-15.9a1.148,1.148,0,0,0-1.148-1.148M33.023,3.094a.609.609,0,0,1-.181.435l.006.006c-.323.28-1.117,1.035-3.365,3.188l.527-4.232h2.41a.6.6,0,0,1,.6.6m-16.056,0a.6.6,0,0,1,.6-.6h2.409L20.5,6.72c-2.246-2.151-3.039-2.906-3.362-3.185l.007-.006a.609.609,0,0,1-.181-.435m4.522-1.486H28.5l-.8,6.438a2.9,2.9,0,0,1-1.9,2.422,2.581,2.581,0,0,1-1.617,0,2.9,2.9,0,0,1-1.9-2.422Zm2.544,10.485a4.132,4.132,0,0,0,1.925,0v2.922H24.032ZM20.5,16.621H29.49v2.27H20.5ZM2.3,29.137H15.9v18.9H2.3Zm15.9-7.949h13.6V48.036h-13.6Zm29.5,26.848h-13.6v-13.6h13.6Z"
                    transform="translate(0 0)"
                    fill="#fff"
                  />
                  <path
                    id="Path_2086"
                    dataname="Path 2086"
                    d="M53.163,61.136a1.226,1.226,0,0,0-.687-.2.775.775,0,0,0-.419.1l-1.909,1.157a.825.825,0,0,0-.419.767,1.022,1.022,0,0,0,.2.621.607.607,0,0,0,.505.274.639.639,0,0,0,.362-.116l.419-.26v7.36a.558.558,0,0,0,.333.513,1.836,1.836,0,0,0,1.59,0,.56.56,0,0,0,.333-.513v-9.2a.594.594,0,0,0-.311-.506"
                    transform="translate(-26.888 -32.945)"
                    fill="#fff"
                  />
                  <path
                    id="Path_2087"
                    dataname="Path 2087"
                    d="M18.516,81.1H14.692v-.132a1.126,1.126,0,0,1,.47-.77,10.291,10.291,0,0,1,1.132-.858q.664-.44,1.319-.967a4.867,4.867,0,0,0,1.122-1.3,3.167,3.167,0,0,0,.466-1.656,2.575,2.575,0,0,0-1.02-2.144,3.747,3.747,0,0,0-2.372-.8,3.612,3.612,0,0,0-2.289.761,2.438,2.438,0,0,0-.973,2.023q0,1.174,1,1.174a1.325,1.325,0,0,0,.852-.255.751.751,0,0,0,.322-.6,1.085,1.085,0,0,1,.309-.858,1.156,1.156,0,0,1,.793-.271,1.022,1.022,0,0,1,1.117,1.04,1.626,1.626,0,0,1-.478,1.056,6.967,6.967,0,0,1-1.169,1.041l-1.331,1A5.568,5.568,0,0,0,12.838,79.7a2.1,2.1,0,0,0-.465,1.255v1.416a.588.588,0,0,0,.325.5,1.241,1.241,0,0,0,.661.2H18.52a.577.577,0,0,0,.478-.3,1.227,1.227,0,0,0,.2-.7,1.15,1.15,0,0,0-.2-.681.585.585,0,0,0-.481-.29"
                    transform="translate(-6.69 -39.182)"
                    fill="#fff"
                  />
                  <path
                    id="Path_2088"
                    dataname="Path 2088"
                    d="M83.579,81.716a1.266,1.266,0,0,0,.825-.2.763.763,0,0,0,.23-.6.607.607,0,0,1,.257-.557,1.53,1.53,0,0,1,.8-.162.919.919,0,0,1,1.057,1.022,2.045,2.045,0,0,1-.093.673.656.656,0,0,1-.272.369,1.135,1.135,0,0,1-.341.142,1.989,1.989,0,0,1-.407.035c-.427,0-.642.288-.642.863s.214.863.641.863a1.816,1.816,0,0,1,1.022.237,1.026,1.026,0,0,1,.351.912v.274a1.389,1.389,0,0,1-.294,1,1.42,1.42,0,0,1-1.023.295q-1.273,0-1.272-.833a.659.659,0,0,0-.24-.583,1.751,1.751,0,0,0-.92-.166,1.47,1.47,0,0,0-.838.173.764.764,0,0,0-.232.647A2.557,2.557,0,0,0,83.054,88a3.557,3.557,0,0,0,2.566.835,4.11,4.11,0,0,0,2.633-.792,2.945,2.945,0,0,0,1-2.458v-.274A2.075,2.075,0,0,0,87.79,83.2a1.717,1.717,0,0,0,.819-.884,3.411,3.411,0,0,0,.3-1.454q0-2.622-3.214-2.623a3.436,3.436,0,0,0-2.486.783,2.445,2.445,0,0,0-.8,1.79.945.945,0,0,0,.21.726,1.659,1.659,0,0,0,.963.18"
                    transform="translate(-44.438 -42.3)"
                    fill="#fff"
                  />
                </g>
              </svg>
            </div>
            <h3>Sports & events cover</h3>
            <p>
              You are covered for participation in Competitive Road Racing,
              Mountain Bike Racing, Triathlons, Duathlons, Ironman™ events,
              Cyclo-Cross and Track Racing.
            </p>
          </div>
          <div className="col-12 col-md-6 col-lg-4 col-xl-4 pr-10">
            <div className="iconBlockBlueLeft mb-3">
              <svg width="56.188" height="51.846" viewBox="0 0 56.188 51.846">
                <defs>
                  <clipPath id="clipPath3">
                    <rect
                      id="Rectangle_968"
                      dataname="Rectangle 968"
                      width="56.188"
                      height="51.846"
                      fill="#fff"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_2134"
                  dataname="Group 2134"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_2134-2"
                    dataname="Group 2134"
                    transform="translate(0 0)"
                    clipPath="url(#clipPath3)"
                  >
                    <path
                      id="Path_2145"
                      dataname="Path 2145"
                      d="M56.162,23.869A28.315,28.315,0,0,0,43.406,5.728C37.46,1.981,29.957,0,21.708,0,5.886,0,.362,9.793.135,10.21a1.085,1.085,0,0,0-.12.7A12.447,12.447,0,0,0,1.4,14.55L7.267,29.06a1.211,1.211,0,0,0,1.128.735c.047,0,4.107.006,6.1,0l5.259,9.611V50.7a1.178,1.178,0,0,0,1.21,1.142h6.452a1.178,1.178,0,0,0,1.21-1.142V33.588a31.751,31.751,0,0,0,4.791-2.905,32.1,32.1,0,0,1,3.776-2.367,40.491,40.491,0,0,1,9.7-3.062l8.088-.006a1.237,1.237,0,0,0,.939-.424,1.094,1.094,0,0,0,.243-.955M26.2,49.562H22.171V39.13a1.094,1.094,0,0,0-.135-.524l-2.737-5a10.5,10.5,0,0,0,4.69,1.051,10.943,10.943,0,0,0,2.214-.243ZM36.061,26.3a34.445,34.445,0,0,0-4.075,2.543c-2.593,1.79-5.043,3.481-7.808,3.531-3.064.056-5.235-1.143-8-4.43a1.238,1.238,0,0,0-.947-.431h-.009c-1.058.006-4.413,0-5.988,0L6.215,20.054c3.518,2.659,9.309,5.17,18.646,5.194,3.413.006,13.159.009,13.559.009-.793.311-1.589.656-2.358,1.039M24.866,22.963c-8.373-.021-14.909-2.176-18.9-6.233a13.531,13.531,0,0,1-3.472-5.8C3.563,9.3,8.94,2.286,21.708,2.286c12.743,0,27.56,5.465,31.743,20.679-1.429,0-22.612.01-28.585,0"
                      transform="translate(0 -0.001)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2146"
                      dataname="Path 2146"
                      d="M55.467,16.078c-4.882-3.076-11.146-4.7-18.116-4.7a1.144,1.144,0,1,0,0,2.285c6.49,0,12.291,1.493,16.773,4.318a20.341,20.341,0,0,1,4.818,4.183h-6.08a1.144,1.144,0,1,0,0,2.285l8.4,0a1.225,1.225,0,0,0,1.056-.586A1.087,1.087,0,0,0,62.29,22.7a22.227,22.227,0,0,0-6.824-6.623"
                      transform="translate(-15.643 -5.284)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <h3>Accessory cover</h3>
            <p>
              Cycling accessories don’t always come cheap, and when your cycle
              has also been stolen or damaged we can provide additional cover
              for these items up to £1000 following a claim.
            </p>
          </div>
          <div className="col-12 col-md-6 offset-md-6 offset-lg-0 col-lg-4 col-xl-4 pr-10">
            <div className="iconBlockBlueLeft mb-3">
              <svg
                id="Group_2139"
                dataname="Group 2139"
                width="47.48"
                height="52.644"
                viewBox="0 0 47.48 52.644"
              >
                <defs>
                  <clipPath id="clipPath4">
                    <rect
                      id="Rectangle_972"
                      dataname="Rectangle 972"
                      width="47.48"
                      height="52.644"
                      fill="#fff"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_2141"
                  dataname="Group 2141"
                  clipPath="url(#clipPath4)"
                >
                  <path
                    id="Path_2157"
                    dataname="Path 2157"
                    d="M46.825,16.708a3.313,3.313,0,0,0-1.71-1.2L34.277,12.235a3.292,3.292,0,0,0-2.536.274,3.258,3.258,0,0,0-1.2,1.163L25.8,21.509a45.309,45.309,0,0,1-6.075-2.714,2.753,2.753,0,0,0,.231-.211,9.6,9.6,0,0,0,2.678-6.626,9.431,9.431,0,0,0-.1-1.379l-1.2-8.072a2.912,2.912,0,0,0-.34-1,2.973,2.973,0,0,0-1.05-1.09,2.858,2.858,0,0,0-2.928-.03,2.893,2.893,0,0,0-1.441,2.5,2.84,2.84,0,0,0,.032.429l1.209,8.114a3.712,3.712,0,0,1,.039.536,3.768,3.768,0,0,1-.894,2.423l-3.281,2.369a5.434,5.434,0,0,0-1.845.817c-.084.057-.16.124-.24.186a5.584,5.584,0,0,0,.661-2.635,5.622,5.622,0,0,0-2.356-4.581l0,0L8.689,10.4l0,0-.206-.133,0,0A5.592,5.592,0,0,0,5.633,9.5h0A5.62,5.62,0,0,0,.909,12.058,5.6,5.6,0,0,0,0,15.117a5.622,5.622,0,0,0,2.563,4.722,5.6,5.6,0,0,0,3.056.908h0a5.664,5.664,0,0,0,2.646-.658,5.535,5.535,0,0,0,.841-.563l-.33.58a5.7,5.7,0,0,0-.744,2.867,6.829,6.829,0,0,0,.229,1.735l.177,7.129a9.57,9.57,0,0,0,3.013,6.755A1.02,1.02,0,1,0,12.849,37.1a7.5,7.5,0,0,1-2.368-5.317l-.18-7.249a1.046,1.046,0,0,0-.039-.251,4.815,4.815,0,0,1-.187-1.312,3.976,3.976,0,0,1,.119-.982,3.387,3.387,0,0,1,.358-.877l.44-.772A3.363,3.363,0,0,1,13.3,18.708a1.018,1.018,0,0,0,.4-.174l3.548-2.562a1,1,0,0,0,.158-.142,5.756,5.756,0,0,0,1.484-3.864,5.629,5.629,0,0,0-.062-.836L17.62,3.014a.846.846,0,0,1,.19-.672.862.862,0,0,1,.224-.189.841.841,0,0,1,.286-.1.769.769,0,0,1,.422.044.915.915,0,0,1,.569.712l1.2,8.072a7.48,7.48,0,0,1-2.022,6.284.739.739,0,0,1-.1.086l-1.149.83a1.02,1.02,0,0,0,.082,1.708,47.272,47.272,0,0,0,7.85,3.665,5.779,5.779,0,0,1,.592.254,1.025,1.025,0,0,0,1.325-.386l5.193-8.592a1.214,1.214,0,0,1,.451-.436,1.237,1.237,0,0,1,.953-.1l10.839,3.275a1.292,1.292,0,0,1,.665.466,1.241,1.241,0,0,1,.249.733,1.158,1.158,0,0,1-.042.309,1.221,1.221,0,0,1-.445.659,1.237,1.237,0,0,1-.736.247,1.205,1.205,0,0,1-.356-.053l-9.214-2.784a1.016,1.016,0,0,0-1.167.449L28.454,25.8a1.023,1.023,0,0,0-.105.815,3.725,3.725,0,0,1,.152,1.05c0,.056,0,.112,0,.166a1.022,1.022,0,0,0,.965,1.065l7.618.4a1.225,1.225,0,0,1,1.138.984l2.23,11.149a1.272,1.272,0,0,1,.024.242,1.232,1.232,0,0,1-.275.771,1.222,1.222,0,0,1-.711.429,1.239,1.239,0,0,1-.243.024h0a1.226,1.226,0,0,1-1.2-.986l-1.887-9.439a1.02,1.02,0,0,0-.947-.818l-6.029-.319a8.466,8.466,0,0,0-3.391.53,5.266,5.266,0,0,1-3.448,0,52.054,52.054,0,0,1-8.713-3.828,1.02,1.02,0,0,0-1.514.918l.07,2.786.249,0v.006l-.249,0h.12l-.12,0a5.767,5.767,0,0,0,2.324,4.516L21.1,41.154a.852.852,0,0,1,.257.307.868.868,0,0,1,.088.379.851.851,0,0,1-.167.505.86.86,0,0,1-.307.257.849.849,0,0,1-.885-.079,1.042,1.042,0,0,0-.195-.114l-1.548-.683a1.02,1.02,0,1,0-.823,1.866l1.447.634a2.886,2.886,0,0,0,.734.363,2.891,2.891,0,0,0,3.217-1.03,2.882,2.882,0,0,0,.568-1.719,2.889,2.889,0,0,0-1.17-2.325l-6.592-4.883a3.724,3.724,0,0,1-1.5-2.934L14.2,30.659a54.122,54.122,0,0,0,7.5,3.15,7.309,7.309,0,0,0,4.793-.023,6.488,6.488,0,0,1,2.582-.409l5.239.277,1.732,8.661a3.266,3.266,0,1,0,6.406-1.281l-2.23-11.149a3.269,3.269,0,0,0-3.03-2.621l-6.7-.353c-.018-.139-.042-.277-.07-.415l4.4-7.274,8.456,2.555a3.308,3.308,0,0,0,2.908-.516,3.272,3.272,0,0,0,1.188-1.753,3.219,3.219,0,0,0,.113-.844,3.294,3.294,0,0,0-.655-1.955M9.211,15.125a3.587,3.587,0,0,1-1.9,3.161,3.643,3.643,0,0,1-3.637-.159,3.545,3.545,0,0,1-1.213-1.321,3.583,3.583,0,0,1,.158-3.637,3.543,3.543,0,0,1,1.322-1.213,3.608,3.608,0,0,1,1.687-.42h0a3.588,3.588,0,0,1,3.161,1.9,3.622,3.622,0,0,1,.42,1.689"
                    transform="translate(0 0)"
                    fill="#fff"
                  />
                  <path
                    id="Path_2158"
                    dataname="Path 2158"
                    d="M55.34,79.241l6.134,2.519a1.02,1.02,0,1,0,.775-1.887l-6.134-2.52a1.02,1.02,0,0,0-.775,1.887"
                    transform="translate(-27.438 -38.757)"
                    fill="#fff"
                  />
                  <path
                    id="Path_2159"
                    dataname="Path 2159"
                    d="M54.956,92.132a1.021,1.021,0,0,0-1.02-1.02H40.285a1.02,1.02,0,1,0,0,2.04h13.65a1.021,1.021,0,0,0,1.02-1.02"
                    transform="translate(-19.692 -45.695)"
                    fill="#fff"
                  />
                  <path
                    id="Path_2160"
                    dataname="Path 2160"
                    d="M72.422,93.913a1.021,1.021,0,0,0-1.4.348L68.7,98.124a1.02,1.02,0,0,0,1.748,1.052l2.326-3.863a1.02,1.02,0,0,0-.348-1.4"
                    transform="translate(-34.38 -47.026)"
                    fill="#fff"
                  />
                  <path
                    id="Path_2161"
                    dataname="Path 2161"
                    d="M28.808,79.795a1.025,1.025,0,1,0,1.025,1.025,1.026,1.026,0,0,0-1.025-1.025"
                    transform="translate(-13.934 -40.019)"
                    fill="#fff"
                  />
                </g>
              </svg>
            </div>
            <h3>Personal accident</h3>
            <p>
              We will pay amounts of up to £10,000 for loss of limb/sight and up
              to £25,000 for permanent total disablement or death.
            </p>
          </div>

          <div
            className="col-4 d-none d-md-block col-md-6 col-lg-4 col-xl-4"
            id="left"
          >
            <img
              src="/static/media/eBike.2866398650af4280b2c3.png"
              alt="Electric Bike"
              className="EbikeAboutus"
            />
          </div>

          <div className="col-12 pr-10 col-md-6 col-lg-4 ">
            <div className="iconBlockBlueLeft mb-3">
              <svg width="48.146" height="50.422" viewBox="0 0 48.146 50.422">
                <defs>
                  <clipPath id="clipPath6">
                    <rect
                      id="Rectangle_794"
                      dataname="Rectangle 794"
                      width="48.146"
                      height="50.423"
                      fill="#fff"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_1929"
                  dataname="Group 1929"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_1759"
                    dataname="Group 1759"
                    transform="translate(0 0)"
                    clipPath="url(#clipPath6)"
                  >
                    <path
                      id="Path_2082"
                      dataname="Path 2082"
                      d="M10.246,15.209h36.4a1.143,1.143,0,0,0,0-2.286H42.286L40.23,6.44c-1.109-3.494-2.2-5.3-3.642-6.049S33.738.1,32.24.587a11.977,11.977,0,0,1-3.793.751,11.985,11.985,0,0,1-3.8-.752C23.154.1,21.74-.35,20.305.392S17.772,2.947,16.664,6.44l-2.056,6.482H10.246a1.143,1.143,0,0,0,0,2.286m6.76-2.286,1.837-5.79c.871-2.746,1.692-4.286,2.51-4.709.591-.3,1.43-.035,2.6.341a14.064,14.064,0,0,0,4.494.861,14.079,14.079,0,0,0,4.5-.864c1.16-.372,2-.644,2.589-.338.819.423,1.64,1.963,2.511,4.709l1.836,5.79Z"
                      transform="translate(-4.374 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2083"
                      dataname="Path 2083"
                      d="M23.988,34.131a1.144,1.144,0,0,0-1.143,1.143,5.922,5.922,0,0,0,11.733,1.143h.944a5.922,5.922,0,0,0,11.733-1.143,1.144,1.144,0,0,0-1.143-1.143Zm20.8,2.287a3.635,3.635,0,0,1-6.9,0Zm-12.567,0a3.635,3.635,0,0,1-6.9,0Z"
                      transform="translate(-10.977 -16.4)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2084"
                      dataname="Path 2084"
                      d="M48.064,63.43a1.133,1.133,0,0,0-.61-.627L36.5,58.095l1.662-5.27a1.143,1.143,0,0,0-1.09-1.486H11.07a1.143,1.143,0,0,0-1.09,1.487l1.662,5.27L.692,62.8a1.144,1.144,0,0,0,.033,2.115A1.124,1.124,0,0,0,1.6,64.9l11.9-5.119a1.139,1.139,0,0,0,.638-1.393l-1.5-4.768h10.3V73.946a1.143,1.143,0,1,0,2.287,0V53.624h10.3l-1.5,4.768a1.14,1.14,0,0,0,.638,1.393l11.9,5.118a1.17,1.17,0,0,0,1.5-.6,1.137,1.137,0,0,0,.011-.875"
                      transform="translate(0 -24.668)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>{" "}
            </div>
            <h3>Theft</h3>
            <p>
              Over 90,000 bike thefts were reported between May 2013 and April
              2014. Our cover includes theft of your bike from the location it
              is insured at home and also when it is away from home.
            </p>
          </div>
          <div className="col-12 pr-10 col-md-6 col-lg-4">
            <div className="iconBlockBlueLeft mb-3">
              <svg width="58.135" height="47.046" viewBox="0 0 58.135 47.046">
                <defs>
                  <clipPath id="clipPath">
                    <rect
                      id="Rectangle_983"
                      dataName="Rectangle 983"
                      width="58.135"
                      height="47.046"
                      fill="#fff"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_2196"
                  data-name="Group 2196"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_2196-2"
                    dataName="Group 2196"
                    transform="translate(0 0)"
                    clipPath="url(#clipPath)"
                  >
                    <path
                      id="Path_2195"
                      dataName="Path 2195"
                      d="M67.389,40.465,46.162,20.981a1.8,1.8,0,0,0-.31-2.132l-.532-.532L48.042,15.6a2.912,2.912,0,0,0,.61-.9l.023.022a2.276,2.276,0,0,0,3.216,0L53.5,13.108a2.275,2.275,0,0,0,0-3.215L44.276.666a2.274,2.274,0,0,0-3.216,0L39.448,2.278a2.277,2.277,0,0,0,0,3.216l.022.022a2.906,2.906,0,0,0-.9.61L27.7,17a2.92,2.92,0,0,0-.611.9l-.021-.021a2.275,2.275,0,0,0-3.216,0L22.236,19.49a2.276,2.276,0,0,0,0,3.215l9.228,9.228a2.274,2.274,0,0,0,3.215,0l1.613-1.613a2.273,2.273,0,0,0,0-3.216l-.023-.023a2.908,2.908,0,0,0,.9-.61l2.722-2.722.532.532a1.825,1.825,0,0,0,2.132.31L62.035,45.819a3.789,3.789,0,1,0,5.354-5.354M41.7,22.925l-.493-.492,2.8-2.8.492.492ZM64.843,45.44l-.015-.257a1.931,1.931,0,0,1-1.419-.624L43.925,23.332l.977-.977L66.129,41.838a1.926,1.926,0,0,1-1.288,3.344Zm-30.5-20.285-5.327-5.327a1.066,1.066,0,0,1,0-1.507L39.89,7.444a1.067,1.067,0,0,1,1.506,0l5.329,5.329a1.067,1.067,0,0,1,0,1.506L35.849,25.155a1.066,1.066,0,0,1-1.507,0M40.765,3.6l1.613-1.612a.441.441,0,0,1,.581,0l9.227,9.227a.412.412,0,0,1,0,.581L50.573,13.4a.413.413,0,0,1-.581,0l-1.919-1.92L40.765,4.177a.412.412,0,0,1,0-.58M35.094,28.712a.4.4,0,0,1-.12.29l-1.612,1.612a.427.427,0,0,1-.581,0l-9.227-9.227a.411.411,0,0,1,0-.581L25.166,19.2a.411.411,0,0,1,.581,0l9.228,9.228a.4.4,0,0,1,.12.289"
                      transform="translate(-10.481 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2196"
                      data-name="Path 2196"
                      d="M28.617,72.742h-.9V71.1A3.522,3.522,0,0,0,24.2,67.587H7.937A3.521,3.521,0,0,0,4.421,71.1v1.637h-.9A3.521,3.521,0,0,0,0,76.259v2.306a.933.933,0,0,0,.932.932H31.2a.933.933,0,0,0,.932-.932V76.259a3.521,3.521,0,0,0-3.517-3.517m-16.525.932a.933.933,0,0,0-.932-.932H6.283V71.1a1.656,1.656,0,0,1,1.654-1.654H24.2A1.656,1.656,0,0,1,25.851,71.1v1.637H24.383a.932.932,0,1,0,0,1.863h4.234a1.656,1.656,0,0,1,1.654,1.654v1.374H1.864V76.259A1.656,1.656,0,0,1,3.518,74.6H11.16a.933.933,0,0,0,.932-.932"
                      transform="translate(0 -32.84)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <h3>Free legal advice </h3>
            <p>
              Legal advice can be invaluable when something happens that could
              give rise to a claim. Legal disputes can be daunting and costly,
              which is why we include free initial legal advice as standard for
              every bicycle insurance policy.
            </p>
          </div>
          <div className="col-12 pr-10 col-md-6 col-lg-4 offset-lg-4 marginTop">
            <div className="iconBlockBlueLeft mb-3">
              <svg width="58.92" height="54.018" viewBox="0 0 58.92 54.018">
                <defs>
                  <clipPath id="clipPath">
                    <rect
                      id="Rectangle_975"
                      dataName="Rectangle 975"
                      width="58.92"
                      height="54.018"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.05"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_2144"
                  data-name="Group 2144"
                  clipPath="url(#clipPath11)"
                >
                  <path
                    id="Path_2181"
                    dataName="Path 2181"
                    d="M63.851,63.9a6.715,6.715,0,0,1,2.3-5.064.808.808,0,0,0-.477-1.416.78.78,0,0,0-.585.2A8.331,8.331,0,0,0,62.233,63.9a8.2,8.2,0,1,0,8.2-8.275.809.809,0,0,0,0,1.618A6.657,6.657,0,1,1,63.851,63.9"
                    transform="translate(-23.519 -21.022)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0.05"
                  />
                  <path
                    id="Path_2182"
                    data-name="Path 2182"
                    d="M58.111,64.58H52.639a11.159,11.159,0,0,0-5.725-20.665,10.914,10.914,0,0,0-2.88.385L41.59,37.263a.673.673,0,0,0-.038-.114l-1.514-4.362a.848.848,0,0,0-.065-.145.78.78,0,0,0-.24-.267.809.809,0,0,0-.321-.134.774.774,0,0,0-.156-.013h-5.9a2.143,2.143,0,0,0,0,4.285.809.809,0,0,0,0-1.617.525.525,0,0,1,0-1.051h5.339l1.1,3.169L21.648,44.908l-2.731-3.916h2.176a.321.321,0,0,1,.315.327.809.809,0,0,0,1.617,0,1.941,1.941,0,0,0-1.932-1.944H15a1.919,1.919,0,0,0-1.933,1.944A1.941,1.941,0,0,0,15,43.262a.809.809,0,0,0,0-1.617.321.321,0,0,1-.315-.326A.307.307,0,0,1,15,40.992h1.943l3.38,4.847-.964.935a10.924,10.924,0,0,0-7.377-2.86A11.159,11.159,0,0,0,6.263,64.58H.809a.809.809,0,0,0,0,1.618H11.986a11.014,11.014,0,0,0,10.68-8.315l3.75.7a3.664,3.664,0,1,0,.3-1.59l-3.756-.7a11.4,11.4,0,0,0,.068-1.236,11.186,11.186,0,0,0-2.547-7.112l.785-.761,4.981,7.141A.808.808,0,1,0,27.57,53.4l-4.977-7.138,17.732-7.714.435,1.257L32.076,53.691a.809.809,0,1,0,1.372.858l7.995-12.784,1.067,3.074a11.159,11.159,0,0,0,4.4,21.358h11.2a.809.809,0,0,0,0-1.618M47.179,55.82a.809.809,0,0,0,.5-1.03l-3.112-8.959a9.3,9.3,0,0,1,2.347-.3,9.447,9.447,0,1,1-3.871.841l3.107,8.949a.807.807,0,0,0,1.029.5M19.313,49.075a9.581,9.581,0,0,1,2.1,5.981c0,.31-.016.625-.046.937L13.67,54.549Zm-7.882,5.394a.79.79,0,0,0-.156.2.776.776,0,0,0-.09.278.809.809,0,0,0,.188.631.8.8,0,0,0,.471.27l9.228,1.732A9.5,9.5,0,1,1,18.2,47.9Zm16.6,3.991A2.02,2.02,0,1,1,30.041,60.5a2.036,2.036,0,0,1-2.009-2.039"
                    transform="translate(0 -12.18)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0.05"
                  />
                  <path
                    id="Path_2183"
                    data-name="Path 2183"
                    d="M17.911,56.461a8.26,8.26,0,1,0-3.625,15.712,8.149,8.149,0,0,0,7.283-4.462.808.808,0,1,0-1.439-.738,6.542,6.542,0,0,1-5.844,3.581,6.657,6.657,0,1,1,2.919-12.638.809.809,0,1,0,.705-1.456"
                    transform="translate(-2.3 -21.022)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0.05"
                  />
                  <path
                    id="Path_2184"
                    dataName="Path 2184"
                    d="M49.44,84.235H38.264a.809.809,0,0,0,0,1.618H49.44a.809.809,0,1,0,0-1.618"
                    transform="translate(-14.155 -31.835)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0.05"
                  />
                  <path
                    id="Path_2185"
                    dataName="Path 2185"
                    d="M32.674,23.02h0a.809.809,0,0,0,.6-.265c3.3-3.639,6.852-9.959,6.852-15.237a7.452,7.452,0,1,0-14.9,0c0,5.247,3.551,11.574,6.851,15.233a.806.806,0,0,0,.6.268m-5.833-15.5a5.835,5.835,0,1,1,11.668,0c0,4.511-2.891,9.946-5.832,13.46-2.944-3.532-5.836-8.973-5.836-13.46"
                    transform="translate(-9.532 0)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0.05"
                  />
                  <path
                    id="Path_2186"
                    dataName="Path 2186"
                    d="M39.148,9.067a4.919,4.919,0,1,0-4.928,4.95,4.955,4.955,0,0,0,4.928-4.95m-1.617,0a3.3,3.3,0,1,1-3.311-3.352A3.325,3.325,0,0,1,37.53,9.067"
                    transform="translate(-11.077 -1.549)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0.05"
                  />
                </g>
              </svg>
            </div>
            <h3>Cycle rescue</h3>
            <p>
              If your bike breaks down more than a mile away from home, getting
              you and your cycle back can be difficult. Our 24/7 Cycle Rescue
              service gets you safely to the nearest repair shop, station,
              overnight accommodation or your home address.
            </p>
          </div>
          <div className="col-12 pr-10 col-md-6 col-lg-4 marginTop">
            <div className="iconBlockBlueLeft mb-3">
              <svg width="61.48" height="50.461" viewBox="0 0 71.48 45.461">
                <defs>
                  <clipPath id="clip-path">
                    <rect
                      id="Rectangle_970"
                      data-name="Rectangle 970"
                      width="61.48"
                      height="34.461"
                      fill="#fff"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_2138"
                  data-name="Group 2138"
                  clipPath="url(#clip-path22)"
                >
                  <path
                    id="Path_2150"
                    data-name="Path 2150"
                    d="M61.478,25.354a13.176,13.176,0,0,0-11.11-12.321c-1.868-.294-3.186.8-4.245,1.684-.156.13-.309.258-.462.379L41.88,4.472l5.68.894A1.131,1.131,0,1,1,47.208,7.6L46,7.411a1.169,1.169,0,0,0-.364,2.31l1.212.191a3.469,3.469,0,1,0,1.079-6.854L40.35,1.865a1.168,1.168,0,0,0-1.291,1.522l1.693,4.9-.105-.008L25.974,5.974c-.044-.134-.839-2.567-.951-2.911l1.625.256A1.176,1.176,0,1,0,27.014,1L20.781.014a1.176,1.176,0,0,0-.366,2.323l2,.315L23.758,6.76,20.948,9.9a13.108,13.108,0,1,0,4.9,13.716l3.5.552a2.213,2.213,0,0,0,1.949-.341l.012-.009c10.02-12.044,10.029-12,10.453-12.507.044.134.812,2.27,1.757,4.9a21.444,21.444,0,0,0-4.85,2.4A7.9,7.9,0,0,0,35.3,24c-.261,1.656.573,3.374,1.309,4.889a14.26,14.26,0,0,1,.744,1.7,4.131,4.131,0,0,0,1.611,2.443,4.23,4.23,0,0,0,2.135.526,6.461,6.461,0,0,1,2.49.534,2.376,2.376,0,0,0,1.937-.133,11.086,11.086,0,0,0,1.314-.758,7,7,0,0,1,1.183-.664,3.27,3.27,0,0,1,1.24.755,6.129,6.129,0,0,0,1.257.853,2.839,2.839,0,0,0,2.008.18,3.984,3.984,0,0,1,1.777.018,3.751,3.751,0,0,0,3.737-.977,5.461,5.461,0,0,0,1.321-1.989,6.526,6.526,0,0,0,.291-1.862,15.783,15.783,0,0,1,.149-1.574,4.461,4.461,0,0,1,.45-.435,2.82,2.82,0,0,0,1.224-2.043c0-.034,0-.068,0-.1M19.054,29.405A10.766,10.766,0,1,1,14.795,9.79a10.625,10.625,0,0,1,4.578,1.877l-7.129,7.977a1.176,1.176,0,0,0,.693,1.945l10.571,1.664a10.741,10.741,0,0,1-4.454,6.152m4.819-8.475L15.435,19.6l5.688-6.366a10.778,10.778,0,0,1,2.118,3.527,10.632,10.632,0,0,1,.632,4.168m2.335.367a12.955,12.955,0,0,0-.758-5.342A13.13,13.13,0,0,0,22.7,11.473l1.9-2.129,4.027,12.335Zm4.615-.471c-.138-.423-3.906-11.963-4.031-12.345L39.42,10.471l-8.6,10.356m27.8,4.829a3.17,3.17,0,0,0-1.24,1.82A18.078,18.078,0,0,0,57.2,29.37a4.509,4.509,0,0,1-.156,1.187,3.045,3.045,0,0,1-.772,1.094c-.386.4-.609.406-1.571.252a6.251,6.251,0,0,0-2.819.039c-.221.061-.4-.036-1.059-.571a5.141,5.141,0,0,0-2.477-1.288,4.38,4.38,0,0,0-2.824,1.035,8.388,8.388,0,0,1-1.11.637,8.959,8.959,0,0,0-3.156-.662,2.691,2.691,0,0,1-.968-.15c-.105-.067-.322-.3-.578-1.1a15.714,15.714,0,0,0-.876-2.028,8.788,8.788,0,0,1-1.111-3.168,1.667,1.667,0,0,1,.02-.261,5.482,5.482,0,0,1,2.376-3.771,18.993,18.993,0,0,1,4.24-2.081c1.4,3.878,2.836,7.871,2.836,7.871a1.17,1.17,0,0,0,.952.77,1.187,1.187,0,0,0,.55-.059,1.175,1.175,0,0,0,.711-1.5l-2.878-8.087c.427-.289.814-.611,1.175-.911.97-.808,1.555-1.259,2.285-1.144A10.7,10.7,0,0,1,59,25.3c-.1.1-.262.252-.382.358"
                    transform="translate(0 10)"
                    fill="#fff"
                  />
                </g>
              </svg>
            </div>
            <h3>Accidental damage</h3>
            <p>
              In 2014 approximately 17,480 adult cyclists were involved in
              reported road cycling accidents. If your bike is damaged it will
              be assessed at a cycle retailer, then you have the option of a
              repairer of your choice or one that we recommend.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyInsureWithVelosure;
